import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import img1 from "../../Assets/Images/aboutussection/About1.png";
import img2 from "../../Assets/Images/aboutussection/About2.png";
import img3 from "../../Assets/Images/aboutussection/About3.png";
import img4 from "../../Assets/Images/aboutussection/About4.png";
import { useNavigate } from "react-router-dom";

function AboutSection() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: false,
      offset: 100,
    });

    return () => AOS.refreshHard();
  }, []);

  const images = [
    { src: img1, border: true, delay: 400 },
    { src: img2, border: false, delay: 500 },
    { src: img3, border: false, delay: 600 },
    { src: img4, border: true, delay: 700 },
  ];

  const stats = [
    { value: "5+", label: "Projects Completed", delay: 700 },
    { value: "200+", label: "Happy Clients", delay: 800 },
  ];

  return (
    <div className="bg-white py-10">
      <section>
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center">
            {/* Images Grid */}
            <div className="order-2 lg:order-1" data-aos="fade-right" data-aos-delay="200">
              <div className="grid grid-cols-2 gap-3 sm:gap-7">
                {images.map(({ src, delay }, idx) => (
                  <div
                    key={idx}
                    className="relative rounded-lg overflow-hidden"
                    data-aos="zoom-in"
                    data-aos-delay={delay}
                  >
                    <img
                      src={src}
                      alt="About"
                      className="w-full h-36 xs:h-40 sm:h-52 md:h-60 lg:h-64 object-cover rounded-lg transition-transform duration-500 ease-in-out transform hover:scale-110"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Text Content */}
            <div className="order-1 lg:order-2 space-y-3">
              {/* About Tagline */}
              <div className="border-l-2 border-[#FF5A3C] pl-3" data-aos="fade-up" data-aos-delay="300">
                <span className="text-[#FF5A3C] text-sm sm:text-base font-medium">
                  About Us
                </span>
              </div>

              {/* Heading */}
              <div data-aos="fade-up" data-aos-delay="300">
                <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold tracking-wider text-gray-900">
                  Step Into the Empire of Elegance – Welcome to{" "}
                  <span className="text-[#FF5A3C]">Covenants!</span>
                </h1>
              </div>

              {/* Description */}
              <div data-aos="fade-up" data-aos-delay="400">
                <p className="text-gray-600 text-sm sm:text-base md:text-md leading-relaxed text-justify max-w-2xl">
                  We bring your dream home to life with innovation, integrity, and
                  precision. Our team is committed to delivering top-quality spaces that
                  reflect your lifestyle and vision.
                </p>
              </div>

              {/* Trust Block + Stats */}
              <div
                className="bg-[#FFF1EF] p-2 sm:p-4 rounded-xl shadow-sm space-y-4 max-w-xl"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900">
                  Professional Trust Building
                </h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  Building trusted, lasting spaces for families and investors.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  {stats.map(({ value, label, delay }, idx) => (
                    <div
                      key={idx}
                      className="bg-white border border-[#FF5A3C] p-4 rounded-xl text-center shadow-md"
                      data-aos={idx % 2 === 0 ? "flip-left" : "flip-right"}
                      data-aos-delay={delay}
                    >
                      <div className="text-3xl sm:text-4xl font-bold text-[#FF5A3C] mb-1">
                        {value}
                      </div>
                      <div className="text-sm sm:text-base font-medium text-[#FF5A3C]">
                        {label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA */}
              <div className="pt-3" data-aos="fade-up" data-aos-delay="300">
                <button onClick={() => { navigate('/projects'); window.scrollTo({ top: 0, behavior: "smooth" }); }} className="bg-[#FF5A3C] hover:bg-red-600 text-white px-6 py-3 sm:px-8 sm:py-4 rounded-lg font-semibold text-sm sm:text-base transition duration-200 transform hover:scale-105">
                  Explore Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutSection;